import * as modules from "./modules/";
import config from "../../../../config";
const { vendor } = config;

const PremiumModal = modules[vendor] ? modules[vendor] : modules["default"];

export default PremiumModal;
